import { consumeBookingRedirect } from './bookingIntent';

export function redirectByRole(role, navigate) {
  const r = (role || '').replace(/^ROLE_/, '');
  if (r === 'ADMIN') navigate('/admin/dashboard');
  else if (r === 'STRUTTURA_ADMIN') navigate('/app/struttura');
  else if (r === 'MEDICO') navigate('/app/medico/dashboard');
  else if (r === 'PAZIENTE') navigate('/app/paziente/dashboard');
  else if (r === 'MERCHANT') navigate('/merchant/dashboard');
  else navigate('/');
}

/** Dopo login/registrazione con successo. */
export function redirectAfterLogin(result, navigate, locationState) {
  const roles = result.roles ?? (result.role ? [result.role.replace(/^ROLE_/, '')] : []);
  const normalized = (Array.isArray(roles) ? roles : []).map((r) =>
    String(r).replace(/^ROLE_/, '')
  );

  if (normalized.length > 1) {
    navigate('/app', { replace: true, state: { fromLogin: true, roles: normalized } });
    return;
  }

  const booking = consumeBookingRedirect(result, locationState);
  if (booking) {
    navigate(booking.path, { replace: true, state: booking.state });
    return;
  }

  redirectByRole(result.role, navigate);
}
